import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import styles from "./ModalPrepagoConTarjeta.module.css";
import React, { useState, useEffect } from "react";
import {
  ConsultarServiciosCuenta_Respuesta,
  ConsultarServiciosCuenta_Parametros,
  builtInputVarConsultarServiciosCuentaInput,
  ConsultarServiciosCuenta_Entrada,
} from "../../Commons/Services/ConsultarServiciosCuentaRest";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import {
  DeterminarComercio_Respuesta,
  DeterminarComercio_Parametros,
  builtInputVarDeterminarComercioInput,
  DeterminarComercio_Entrada,
} from "../../Commons/Services/GwDeterminarComercioEBS";
import {
  ConsultarBines_Respuesta,
  ConsultarBines_Parametros,
  ConsultarBines_Entrada,
} from "../../Commons/Services/GwConsultarBinesEBS";
import {
  GenerarIdentificadorUnicoDePago_Respuesta,
  GenerarIdentificadorUnicoDePago_Parametros,
  GenerarIdentificadorUnicoDePago_Entrada,
  builtInputVarGenerarIdentificadorUnicoDePagoInput,
} from "../../Commons/Services/GwGenerarIdentificadorUnicoDePagoEBS";
import ConfirmMessage2 from "../../General/ConfirmMessage2";
import {
  EvaluarRiesgo_Respuesta,
  EvaluarRiesgo_Parametros,
  EvaluarRiesgo_Entrada,
  builtEvaluarRiesgo_Entrada,
  buildNumberAndValuerparams,
  DatosComerciante,
  builtDatosComerciante,
  DatosTarjeta,
  builtDatosTarjeta,
  ComercioInfo,
  builtComercioInfo,
  InstrumentoDePago,
  builtInstrumentoDePago,
  PagoInfo,
  builtPagoInfo,
  DireccionFacturacion,
  builtDireccionFacturacion,
  DetalleMonto,
  builtDetalleMonto,
  OrdenInfo,
  builtOrdenInfo,
  SubComercianteInfo,
  builtSubComercianteInfo,
  AgregadorDePagoInfo,
  builtAgregadorDePagoInfo,
} from "../../Commons/Services/GwEvaluarRiesgoEBS";
import {
  ActualizarBilletera_Respuesta,
  ActualizarTDCBilletera_Parametros,
  ActualizarTDCBilletera_Entrada,
  builtActualizarTDCBilleteraInput,
} from "../../Commons/Services/GwActualizarTDCBilleteraEBS";
import {
  ConsultarTipoCambio_Respuesta,
  ConsultarTipoCambio_Parametros,
  ConsultarTipoCambio_Entrada,
  ConsultarTipoCambioInput,
} from "../../Commons/Services/GwConsultarTipoCambioEBS";
import {
  OrquestarProcesoPago_Respuesta,
  OrquestarProcesoPago_Parametros,
  OrquestarProcesoPago_Entrada,
  builtOrquestarProcesoPago_Entrada,
  builtDatosTarjetaEntrada,
  builtDatosTransaccionEntrada,
  DatosTarjetaEntrada,
  DatosTransaccionEntrada,
} from "../../Commons/Services/GwOrquestarProcesoPagoPMPEBF";
import LoadingSpinner from "../../Spinner/LoadingSpinner";
import { ConsultarBilletera_Info } from "../../Commons/Services/GwConsultarBilleteraEBF";
import CardGallery from "./items/CardGallery";
import {
  builtGwGenerarJWTokenEBSEntrada,
  GwGenerarJWTokenEBS_Entrada,
  GwGenerarJWTokenEBS_Parametros,
  GwGenerarJWTokenEBS_Respuesta,
} from "../../Commons/Services/GwGenerarJWTokenEBS";
import { determinaMoneda } from "../../Utils/Monedas";
import {
  GwValidarReto3DSEBS_Entrada,
  builtGwValidarReto3DSEBSInput,
  GwValidarReto3DSEBS_Parametros,
  GwValidarReto3DSEBS_Respuesta,
} from "../../Commons/Services/GwValidarReto3DSEBS";
import {
  GwEvaluarReto3DSEBS_Entrada,
  builtGwEvaluarReto3DSEBSInput,
  GwEvaluarReto3DSEBS_Parametros,
  GwEvaluarReto3DSEBS_Respuesta,
  DispositivoInfo,
  builtDispositivoInfo,
} from "../../Commons/Services/GwEvaluarReto3DSEBS";
import {
  GwProcesarTransaccionDMEBS_Entrada,
  builtGwProcesarTransaccionDMEBSInput,
  GwProcesarTransaccionDMEBS_Parametros,
  GwProcesarTransaccionDMEBS_Respuesta,
} from "../../Commons/Services/GwProcesarTransaccionDMEBS";

import { v4 as uuidv4 } from "uuid";

const ModalPrepagoConTarjeta = (props: any) => {
  const { allItCards, saldoAPagar, fechaLimite, origen }: any = { ...props };

  const [isPaymentPrcessOn, setIsPaymentPrcessOn] = useState(false);
  const [myInputCVV, setMyInputCVV] = useState("");
  const [cleanCVV, setCleanCVV] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [changeCardClicked, setChangeCardClicked] = useState(false);
  const [confirmPaymentClicked, setConfirmPaymentClicked] = useState(false);
  const [otherQuantity, setOtherQuantity] = useState("");
  const [initialPositionArray, setInitialPositionArray] = useState(0);
  const [initialPositionArrayBKP, setInitialPositionArrayBKP] = useState(0);
  const [uuidValue, setUuidValue] = useState(0);
  const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));
  const [showModalReto, setShowModalReto] = useState(false);

  const [sessionIdDFP, setSessionIdDFP] = useState("");
  const [eventoDisparado, setEventoDisparado] = useState(false);

  useEffect(() => {
    setInitialPositionArray(0);
    setOtherQuantity("");
    setMyInputCVV("");

    const currentDate = formatDateToString(new Date(), "DDMMyyyy_HH_mm_ss");
    const sesionId =
      sessionStorage.getItem("cuenta") + "_" + currentDate + "_SEL";
    setSessionIdDFP(sesionId);
  }, []);

  const doConfirmPaymentCard = async (p_card: ConsultarBilletera_Info) => {
    var datosFlag = doValidacionesDatos(p_card);
    if (datosFlag) {
      var longitudesFlag = doValidacionesLogitudes(p_card);
      if (longitudesFlag) {
        setConfirmPaymentClicked(true);
      }
    }
  };

  const doValidareLoginUser = (
    p_ConsultarServiciosCuentaRespuesta: ConsultarServiciosCuenta_Respuesta
  ) => {
    if (p_ConsultarServiciosCuentaRespuesta != null) {
      return p_ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId;
    } else {
      return uuidv4();
    }
  };

  /*const doPaymentCard = async (p_card: ConsultarBilletera_Info) => {
    setIsLoading(true);

    // loadingScriptDFP(p_card);

    //setTimeout(() => {
    setIsPaymentPrcessOn(true);
    //1 determinarcomercio
    doDeterminarComercio(p_card).then((determinarComercioRet) => {
      if (determinarComercioRet != null) {
        //2 consultar bines
        doConsultarBines(p_card).then((consultarBinesRet) => {
          if (consultarBinesRet != null) {
            //3 vincular uuid
            doVincularUUID();
            //4 generar identificador unico de pago
            doGenerarIdentificadorUnicoDePago(consultarBinesRet!).then(
              (generarIdentificadorUnicoDePagoRet) => {
                if (generarIdentificadorUnicoDePagoRet != null) {
                  //5 evaluar riesgo
                  doEvaluarRiesgo(
                    determinarComercioRet!,
                    generarIdentificadorUnicoDePagoRet!,
                    p_card
                  ).then((evaluarRiesgoRet) => {
                    if (evaluarRiesgoRet != null) {
                      //6 guardar evaluacion actualizar billetera
                      doActualizarBilletera(
                        evaluarRiesgoRet!,
                        p_card,
                        null,
                        null,
                        false,
                        false
                      ).then((actualizarBilleteraRet) => {
                        if (actualizarBilleteraRet != null) {
                          //DESPUES DE CONSULTAR RIESGO SE ACTUALIZA BILLETERA PARA QUE QUEDE REGISTRO
                          //LAS OPCIONES QUE NOS DEVUELVE EVALUAR RIESGO SON: PENDING_REVIEW,ACCEPTED,REJECTED

                          if (evaluarRiesgoRet.EstatusRiesgo == "ACCEPTED") {
                            resumeFlowAfterConsultingExchangeRate(
                              p_card,
                              determinarComercioRet,
                              consultarBinesRet,
                              generarIdentificadorUnicoDePagoRet
                            );
                          } else {
                            redirectToError();
                          }
                        } else {
                          redirectToError();
                        }
                      });
                    } else {
                      redirectToError();
                    }
                  });
                } else {
                  redirectToError();
                }
              }
            );
          } else {
            redirectToError();
          }
        });
      } else {
        redirectToError();
      }
    });
    // }, 3000);
  };*/

  const doPaymentCard = async (p_card: ConsultarBilletera_Info) => {
    setIsLoading(true);

    loadingScriptDFP(p_card);

    setTimeout(() => {
      setIsPaymentPrcessOn(true);
      //1 determinarcomercio
      doDeterminarComercio(p_card).then((determinarComercioRet) => {
        if (determinarComercioRet != null) {
          //2 consultar bines
          doConsultarBines(p_card).then((consultarBinesRet) => {
            if (consultarBinesRet != null) {
              //3 vincular uuid
              doVincularUUID();
              //4 generar identificador unico de pago
              doGenerarIdentificadorUnicoDePago(consultarBinesRet!).then(
                (generarIdentificadorUnicoDePagoRet) => {
                  if (generarIdentificadorUnicoDePagoRet != null) {
                    //5 evaluar riesgo
                    doEvaluarRiesgo(
                      determinarComercioRet!,
                      generarIdentificadorUnicoDePagoRet!,
                      p_card
                    ).then((evaluarRiesgoRet) => {
                      if (evaluarRiesgoRet != null) {
                        //6 guardar evaluacion actualizar billetera
                        doActualizarBilletera(
                          evaluarRiesgoRet!,
                          p_card,
                          null,
                          null,
                          false,
                          false
                        ).then((actualizarBilleteraRet) => {
                          if (actualizarBilleteraRet != null) {
                            //DESPUES DE CONSULTAR RIESGO SE ACTUALIZA BILLETERA PARA QUE QUEDE REGISTRO
                            //LAS OPCIONES QUE NOS DEVUELVE EVALUAR RIESGO SON: PENDING_REVIEW,ACCEPTED,REJECTED

                            if (
                              evaluarRiesgoRet.EstatusRiesgo == "PENDING_REVIEW"
                            ) {
                              doGenerarJWTokenEBS(
                                determinarComercioRet,
                                generarIdentificadorUnicoDePagoRet,
                                p_card
                              ).then((GenerarJWTokenEBSRet: any) => {
                                if (GenerarJWTokenEBSRet != null) {
                                  doEjecutarDeviceDataCollectionIFrame(
                                    GenerarJWTokenEBSRet!,
                                    determinarComercioRet,
                                    generarIdentificadorUnicoDePagoRet,
                                    p_card,
                                    consultarBinesRet,
                                    evaluarRiesgoRet
                                  );
                                } else {
                                  console.error(
                                    "GenerarJWTokenEBSRet",
                                    GenerarJWTokenEBSRet
                                  );
                                  redirectToError();
                                }
                              });
                            } else if (
                              evaluarRiesgoRet.EstatusRiesgo == "ACCEPTED"
                            ) {
                              resumeFlowAfterConsultingExchangeRate(
                                p_card,
                                determinarComercioRet,
                                consultarBinesRet,
                                generarIdentificadorUnicoDePagoRet,
                                null,
                                null,
                                null
                              );
                            } else if (
                              evaluarRiesgoRet.EstatusRiesgo == "REJECTED" ||
                              evaluarRiesgoRet.EstatusRiesgo == "DECLINED"
                            ) {
                              console.error(
                                "evaluarRiesgoRet.EstatusRiesgo == REJECTED DECLINED",
                                evaluarRiesgoRet
                              );
                              redirectToError();
                            } else {
                              console.error(
                                "evaluarRiesgoRet.EstatusRiesgo == UNKNOW",
                                evaluarRiesgoRet
                              );
                              redirectToError();
                            }
                          } else {
                            console.error(
                              "evaluarRiesgoRet nulo",
                              evaluarRiesgoRet
                            );
                            redirectToError();
                          }
                        });
                      } else {
                        console.error(
                          "evaluarRiesgoRet nulo",
                          evaluarRiesgoRet
                        );
                        redirectToError();
                      }
                    });
                  } else {
                    console.error(
                      "generarIdentificadorUnicoDePagoRet nulo",
                      generarIdentificadorUnicoDePagoRet
                    );
                    redirectToError();
                  }
                }
              );
            } else {
              console.error("consultarBinesRet nulo ", consultarBinesRet);
              redirectToError();
            }
          });
        } else {
          console.error("determinarComercioRet nulo ", determinarComercioRet);
          redirectToError();
        }
      });
    }, 3000);
  };

  //1111111111111111111111
  const doDeterminarComercio = async (p_card: ConsultarBilletera_Info) => {
    try {
      //var myLocalSelectedCardVar = mySelectedCard as any;

      //----------------------------------------------------------------------------------------------------------------------------
      const DeterminarComercioDO: DeterminarComercio_Entrada =
        builtInputVarDeterminarComercioInput(
          `${p_card.CodPais}`,
          "SEL",
          `${p_card.TipoTarjeta}`,
          "N"
        );
      let par = DeterminarComercio_Parametros(DeterminarComercioDO);
      let DeterminarComercioRespuesta: DeterminarComercio_Respuesta =
        await ConsultaWS(par);
      if (
        DeterminarComercioRespuesta.EBMHeaderResponse &&
        DeterminarComercioRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        DeterminarComercioRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
          "ok" &&
        DeterminarComercioRespuesta.BilleteraComercioCollection
          .BilleteraComercio &&
        DeterminarComercioRespuesta.BilleteraComercioCollection
          .BilleteraComercio != null &&
        DeterminarComercioRespuesta.BilleteraComercioCollection
          .BilleteraComercio.length > 0 &&
        typeof DeterminarComercioRespuesta.BilleteraComercioCollection
          .BilleteraComercio != "undefined"
      ) {
        return DeterminarComercioRespuesta;
      } else {
        return errorAndReturnNull(DeterminarComercioRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doConsultarBines = async (p_card: ConsultarBilletera_Info) => {
    try {
      const ConsultarBinesDO: ConsultarBines_Entrada = {
        CardBIN: `${p_card.MaskedPan.substring(0, 6)}`,
        CardNumber: "",
        CountryCode: `${p_card.CodPais}`,
      };
      let par = ConsultarBines_Parametros(ConsultarBinesDO);
      let ConsultarBinesRespuesta: ConsultarBines_Respuesta = await ConsultaWS(
        par
      );
      if (
        ConsultarBinesRespuesta.EBMHeaderResponse &&
        ConsultarBinesRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
        ConsultarBinesRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok" &&
        ConsultarBinesRespuesta.ClasificacionesLlamada.ClearingHouse &&
        ConsultarBinesRespuesta.ClasificacionesLlamada.ClearingHouse != null &&
        typeof ConsultarBinesRespuesta.ClasificacionesLlamada.ClearingHouse !=
          "undefined"
      ) {
        return ConsultarBinesRespuesta;
      } else {
        return errorAndReturnNull(ConsultarBinesRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doVincularUUID = () => {
    setUuidValue(Math.random());
  };

  const doGenerarIdentificadorUnicoDePago = async (
    p_consultarbines: ConsultarBines_Respuesta
  ) => {
    try {
      const GenerarIdentificadorUnicoDePagoDO: GenerarIdentificadorUnicoDePago_Entrada =
        builtInputVarGenerarIdentificadorUnicoDePagoInput(
          `${p_consultarbines.ClasificacionesLlamada.ClearingHouse}`,
          `${sessionStorage.getItem("cuenta")}`,
          "PAGO",
          "SEL"
        );
      let par = GenerarIdentificadorUnicoDePago_Parametros(
        GenerarIdentificadorUnicoDePagoDO
      );
      let GenerarIdentificadorUnicoDePagoRespuesta: GenerarIdentificadorUnicoDePago_Respuesta =
        await ConsultaWS(par);

      if (
        GenerarIdentificadorUnicoDePagoRespuesta.EBMHeaderResponse &&
        GenerarIdentificadorUnicoDePagoRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        GenerarIdentificadorUnicoDePagoRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok" &&
        GenerarIdentificadorUnicoDePagoRespuesta.Salida_Process.IdPagoSKY &&
        GenerarIdentificadorUnicoDePagoRespuesta.Salida_Process.IdPagoSKY !=
          null &&
        typeof GenerarIdentificadorUnicoDePagoRespuesta.Salida_Process
          .IdPagoSKY != "undefined"
      ) {
        return GenerarIdentificadorUnicoDePagoRespuesta;
      } else {
        return errorAndReturnNull(GenerarIdentificadorUnicoDePagoRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doEvaluarRiesgo = async (
    p_determinarComercio: DeterminarComercio_Respuesta,
    p_generaridentificador: GenerarIdentificadorUnicoDePago_Respuesta,
    p_card: ConsultarBilletera_Info
  ) => {
    try {
      const datosTarjeta: DatosTarjeta = builtDatosTarjeta(
        "", //mes
        "", //año
        "", //tipo tarjeta
        "" //numero
      );

      const instrumentoDePago: InstrumentoDePago = builtInstrumentoDePago(
        `${p_card.PaymentInstrument}`
      );

      const pagoInfo: PagoInfo = builtPagoInfo(datosTarjeta, instrumentoDePago);
      //
      const direccionFacturacion: DireccionFacturacion =
        builtDireccionFacturacion(
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      var cantidadNueva = !(otherQuantity.length < 1)
        ? otherQuantity
        : saldoAPagar;
      const detallesCantidad: DetalleMonto = builtDetalleMonto(
        erraseCommaCharacter(cantidadNueva),
        `${p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0].monedaIso}`
      );

      const ordenInfo: OrdenInfo = builtOrdenInfo(
        direccionFacturacion,
        detallesCantidad
      );

      const subComercianteInfo: SubComercianteInfo = builtSubComercianteInfo(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
      //
      const agregadorDePagoInfo: AgregadorDePagoInfo = builtAgregadorDePagoInfo(
        "",
        "",
        subComercianteInfo
      );
      //let codigoSkyDM =p_generaridentificador.Salida_Process.IdPagoSKY.replaceAll("PAGO","DM");
      let codigoSkyDM = p_generaridentificador.Salida_Process.IdPagoSKY;
      const comercioInfo: ComercioInfo = builtComercioInfo(
        p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0]
          .mid,
        codigoSkyDM,
        "",
        "internet"
      );
      //const currentDate = formatDateToString(new Date(), "DDMMyyyy_HH_mm_ss");
      //const sesionId = sessionStorage.getItem("cuenta") + "_" + currentDate + "_SEL";
      const EvaluarRiesgoDO: EvaluarRiesgo_Entrada = builtEvaluarRiesgo_Entrada(
        comercioInfo,
        agregadorDePagoInfo,
        ordenInfo,
        pagoInfo,
        builtDatosComerciante(
          buildNumberAndValuerparams(
            `${p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0].afiliacion}`
          )
        ),
        `${sessionStorage.getItem("IPv4")}`,
        `${sessionIdDFP}`
      );

      let par = EvaluarRiesgo_Parametros(EvaluarRiesgoDO);

      let EvaluarRiesgoRespuesta: EvaluarRiesgo_Respuesta = await ConsultaWS(
        par
      );

      if (
        EvaluarRiesgoRespuesta.EBMHeaderResponse &&
        EvaluarRiesgoRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
        EvaluarRiesgoRespuesta.EBMHeaderResponse.ErrorTecnico.code === "0" &&
        EvaluarRiesgoRespuesta.EstatusRiesgo &&
        EvaluarRiesgoRespuesta.EstatusRiesgo != null &&
        typeof EvaluarRiesgoRespuesta.EstatusRiesgo != "undefined" &&
        EvaluarRiesgoRespuesta.FechaTransaccionUTC &&
        EvaluarRiesgoRespuesta.FechaTransaccionUTC != null &&
        typeof EvaluarRiesgoRespuesta.FechaTransaccionUTC != "undefined"
      ) {
        return EvaluarRiesgoRespuesta;
      } else {
        return errorAndReturnNull(EvaluarRiesgoRespuesta);
      }
      //---------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doActualizarBilletera = async (
    p_evaluarriesgo: EvaluarRiesgo_Respuesta | null,
    p_card: ConsultarBilletera_Info,
    p_ValidarReto3ds: GwValidarReto3DSEBS_Respuesta | null,
    p_EvaluarReto3DSE: GwEvaluarReto3DSEBS_Respuesta | null,
    p_isStepupShow: boolean,
    p_fromChallenge: boolean
  ) => {
    try {
      const ActualizarTDCBilleteraDO: ActualizarTDCBilletera_Entrada =
        builtActualizarTDCBilleteraInput(
          `${p_card.Id}`,
          `${p_card.PaymentInstrument}`,
          "",
          `${sessionStorage.getItem("cuenta")}`,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          p_fromChallenge
            ? `${
                p_isStepupShow
                  ? p_ValidarReto3ds!.RespuestaGenerarReto.EstadoSky.Estado
                  : p_EvaluarReto3DSE!.RespuestaGenerarReto.EstadoSky.Estado
              }`
            : `${p_evaluarriesgo!.EstatusRiesgo}`, //,
          p_fromChallenge ? `` : `${p_evaluarriesgo!.FechaTransaccionUTC}`, //,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      let par = ActualizarTDCBilletera_Parametros(ActualizarTDCBilleteraDO);

      let ActualizarBilleteraRespuesta: ActualizarBilletera_Respuesta =
        await ConsultaWS(par);

      if (
        ActualizarBilleteraRespuesta.EBMHeaderResponse &&
        ActualizarBilleteraRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        ActualizarBilleteraRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
          "ok"
      ) {
        return ActualizarBilleteraRespuesta;
      } else {
        return errorAndReturnNull(ActualizarBilleteraRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doConsultarTipoCambio = async (p_card: ConsultarBilletera_Info) => {
    try {
      const ConsultarTipoCambioDO: ConsultarTipoCambio_Entrada =
        ConsultarTipoCambioInput("1", `${p_card.CodPais}`);
      let par = ConsultarTipoCambio_Parametros(ConsultarTipoCambioDO);

      let ConsultarTipoCambioRespuesta: ConsultarTipoCambio_Respuesta =
        await ConsultaWS(par);

      if (
        ConsultarTipoCambioRespuesta.EBMHeaderResponse &&
        ConsultarTipoCambioRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        ConsultarTipoCambioRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
          "ok" &&
        ConsultarTipoCambioRespuesta.BilleteraTipoCambioCollection
          .BilleteraTipoCambio &&
        ConsultarTipoCambioRespuesta.BilleteraTipoCambioCollection
          .BilleteraTipoCambio != null &&
        ConsultarTipoCambioRespuesta.BilleteraTipoCambioCollection
          .BilleteraTipoCambio.length > 0 &&
        typeof ConsultarTipoCambioRespuesta.BilleteraTipoCambioCollection
          .BilleteraTipoCambio != "undefined"
      ) {
        return ConsultarTipoCambioRespuesta;
      } else {
        return errorAndReturnNull(ConsultarTipoCambioRespuesta);
      }
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doConsultarServiciosCuentaRest = async () => {
    if (flujo !== "Sky+") {
      try {
        const ConsultarServiciosCuentaDO: ConsultarServiciosCuenta_Entrada =
        builtInputVarConsultarServiciosCuentaInput(
          `${
            flujo === "Sky+"
              ? sessionStorage.getItem("cuenta")!
              : sessionStorage.getItem("cuenta")!
          }`
        );
        let par = ConsultarServiciosCuenta_Parametros(
          ConsultarServiciosCuentaDO
        );
        let ConsultarServiciosCuentaRespuesta: ConsultarServiciosCuenta_Respuesta =
          await ConsultaWS(par);
        if (
          ConsultarServiciosCuentaRespuesta.EBMHeaderResponse &&
          ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorNegocio
            .Estado == "ok" &&
          ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorTecnico
            .code === "ok" &&
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId &&
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId != null &&
          typeof ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId !=
            "undefined"
        ) {
          return ConsultarServiciosCuentaRespuesta;
        } else {
          return errorAndReturnNull(ConsultarServiciosCuentaRespuesta);
        }
      } catch (error) {
        return errorAndReturnNull(error);
      }
    }
  };

  const builtFechaExpTarjeta = (p_FechaExp: any) => {
    return `${p_FechaExp.substring(5, 7)}${p_FechaExp.substring(0, 2)}`;
  };

  const getTransactionId = (param1: any) => {
    var arrayDeCadenas = param1.split("_");

    return arrayDeCadenas[1] + "_" + arrayDeCadenas[2];
  };

  const doOrquestarPago = async (
    p_determinarComercio: DeterminarComercio_Respuesta,
    p_consultarbines: ConsultarBines_Respuesta,
    p_generaridentificador: GenerarIdentificadorUnicoDePago_Respuesta,
    p_consultartipocambio: ConsultarTipoCambio_Respuesta,
    p_loginUsr: string,
    p_card: ConsultarBilletera_Info,
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null,
    transactionIdFromBank: string | null
  ) => {
    try {
      let codigoSkyDM = p_generaridentificador.Salida_Process.IdPagoSKY;

      var cantidadNueva = !(otherQuantity.length < 1)
        ? otherQuantity
        : saldoAPagar;
      let transactionIdFromBankL =
        transactionIdFromBank != null ? transactionIdFromBank : "";
      var datosTarjetaEntrada: DatosTarjetaEntrada = builtDatosTarjetaEntrada(
        `${p_card.TipoTarjeta.substring(1)}`, //p_tipoTarjeta: string, ->p_card.TipoTarjeta
        `${p_card.MaskedPan}`, //p_numeroTarjeta: string,
        builtFechaExpTarjeta(p_card.FechaExp), //p_fechaExpTarjeta: string,
        `${myInputCVV}`, //p_cvvTarjeta: string,
        `${p_card.NombreTarjeta}`, //p_nombreTitularTarjeta: string,
        `${p_consultarbines.ClasificacionesLlamada.CardType}` //p_nombreEmpresaTransaccion: string
      );

      var datosTransaccionEntrada: DatosTransaccionEntrada =
        builtDatosTransaccionEntrada(
          "AplicarPago", //p_tipoOperacion: string,
          `${getTransactionId(
            p_generaridentificador.Salida_Process.IdPagoSKY
          )}`, //p_idTransaccion: string,
          `${sessionStorage.getItem("cuenta")}`, //p_numeroCuentaClienteSky: string,
          p_loginUsr, //p_loginUsr: string,
          `${horaFormateada()}`, //p_horaActual: string,
          `${fechaFormateada()}`, //p_fechaActual: string,
          "1", //p_propositoPago: string,
          erraseCommaCharacter(cantidadNueva), //p_importePago: string,
          `${importePagoMonedaLocal(
            erraseCommaCharacter(cantidadNueva),
            p_consultartipocambio.BilleteraTipoCambioCollection
              .BilleteraTipoCambio[0].tasa
          )}`, //p_importePagoMonedaLocal: string,
          `${p_consultartipocambio.BilleteraTipoCambioCollection.BilleteraTipoCambio[0].tasa}`, //p_tipoCambio: string,
          `${nombrepais(p_card.CodPais)}`, //p_pais: string,
          "", //p_codeStore: string,
          "", //p_authidresponse: string,
          "", //p_clerkId: string,
          "", //p_origFecha: string,
          "", //p_origHora: string,
          "", //p_origStan: string,
          "", //p_origMsg: string,
          "SEL", //p_sistemaOrigenPago: string,
          `${p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0].codigoMoneda}`, //p_codigoMoneda: string,
          `${p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0].clearingHouse}`, //p_entidadBancaria: string,
          "Tarjeta de " +
            p_consultarbines.ClasificacionesLlamada.BINType.substring(
              0,
              1
            ).toUpperCase() +
            p_consultarbines.ClasificacionesLlamada.BINType.substring(
              1
            ).toLowerCase(), //p_tipoPago: string,
          "Y", //p_tokenVoltage: string,
          "", //p_comentarios: string,
          `${p_determinarComercio.BilleteraComercioCollection.BilleteraComercio[0].mid}`, //p_MerchantId: string,
          `${codigoSkyDM}`, //p_CodigoSKY: string,
          "true", //p_Captura: string,
          `${p_card.PaymentInstrument}`, //p_Token: string,
          "", //p_InstrumentIdentifier: string,
          `${sessionStorage.getItem("idSesion")}`, //p_IdSesion: string,
          geteCommerceIndicator(p_validarretoeds, p_evaluarreto), //p_EcommerceIndicator: string,
          "", //p_AuthenticationTransactioId: string,
          getcavvReto(p_validarretoeds, p_evaluarreto), //p_Cavv: string,
          "", //p_Eci: string,
          getxidReto(p_validarretoeds, p_evaluarreto), //p_xid: string,
          "", //p_transactionID: string,
          "", //p_IdentificadorCliente: string,
          geteciRawReto(p_validarretoeds, p_evaluarreto), //p_EciRaw: string,
          getucafCollectionIndicator(p_validarretoeds, p_evaluarreto), //p_IndicadorDeCobroUcaf: string,
          getucafAutenticationData(p_validarretoeds, p_evaluarreto), //p_DatosDeAutenticacionUcaf: string,
          getdirectoryServerTransactionId(p_validarretoeds, p_evaluarreto), //p_IdentificadorTransaccionServidor: string,
          getspecificationVersion(p_validarretoeds, p_evaluarreto), //p_Version3DS: string,
          "", //p_CredencialAlmacenadaEnArchivo: string,
          "", //p_CredencialAlmacenadaEnUso: string,
          "", //p_IdentificadorTransaccionRed: string,
          "", //p_DatosEmisor: string,
          transactionIdFromBankL, //p_TransaccionAutenticacionId: string,------------------------------------------------------------vaidarretor.enrollment..
          "", //p_p_DestinoPayPal: string,
          "" //p_ProcesoPayPal: string
        );

      var orquestarProcesoPago_Entrada: OrquestarProcesoPago_Entrada =
        builtOrquestarProcesoPago_Entrada(
          datosTarjetaEntrada,
          datosTransaccionEntrada
        );

      let OrquestarProcesoPagoParametros = OrquestarProcesoPago_Parametros(
        orquestarProcesoPago_Entrada
      );

      let OrquestarProcesoPagoRespuesta: OrquestarProcesoPago_Respuesta =
        await ConsultaWS(OrquestarProcesoPagoParametros);

      if (
        OrquestarProcesoPagoRespuesta.EBMHeaderResponse &&
        OrquestarProcesoPagoRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        OrquestarProcesoPagoRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
          "ok" &&
        OrquestarProcesoPagoRespuesta.RespuestaPagoTarjeta &&
        OrquestarProcesoPagoRespuesta.RespuestaPagoTarjeta != null &&
        typeof OrquestarProcesoPagoRespuesta.RespuestaPagoTarjeta != "undefined"
      ) {
        return OrquestarProcesoPagoRespuesta;
      } else {
        return errorAndReturnNull(OrquestarProcesoPagoRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const getxidReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_xid = "";
    if (p_validarretoeds != null) {
      v_xid =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.xid;
      if (v_xid != null) {
        return v_xid;
      }
    }

    if (p_evaluarreto != null && (v_xid == "" || v_xid == null)) {
      v_xid = p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion.xid;
      if (v_xid != null) {
        return v_xid;
      }
    }

    return "";
  };

  const getveresEnrolledReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_veresEnrolled = "";
    if (p_validarretoeds != null) {
      v_veresEnrolled =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .veresEnrolled;
      if (v_veresEnrolled != null) {
        return v_veresEnrolled;
      }
    }
    if (
      p_evaluarreto != null &&
      (v_veresEnrolled == "" || v_veresEnrolled == null)
    ) {
      v_veresEnrolled =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .veresEnrolled;
      if (v_veresEnrolled != null) {
        return v_veresEnrolled;
      }
    }

    return "";
  };

  const gettokenReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_token = "";
    if (p_validarretoeds != null) {
      v_token =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.token;
      if (v_token != null) {
        return v_token;
      }
    }
    if (p_evaluarreto != null && (v_token == "" || v_token == null)) {
      v_token =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion.token;
      if (v_token != null) {
        return v_token;
      }
    }

    return "";
  };

  const geteciRawReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_eciRaw = "";

    if (p_validarretoeds != null) {
      v_eciRaw =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.eciRaw;
      if (v_eciRaw != null) {
        return v_eciRaw;
      }
    }

    if (p_evaluarreto != null && (v_eciRaw == "" || v_eciRaw == null)) {
      v_eciRaw =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion.eciRaw;
      if (v_eciRaw != null) {
        return v_eciRaw;
      }
    }

    return "";
  };

  const getparResReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_parRes = "";
    if (p_validarretoeds != null) {
      v_parRes =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.parRes;
      if (v_parRes != null) {
        return v_parRes;
      }
    }

    if (p_evaluarreto != null && (v_parRes == "" || v_parRes == null)) {
      v_parRes =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion.parRes;
      if (v_parRes != null) {
        return v_parRes;
      }
    }

    return "";
  };

  const getucafCollectionIndicator = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_ucafCollectionIndicator = "";
    if (p_validarretoeds != null) {
      v_ucafCollectionIndicator =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .ucafCollectionIndicator;
      if (v_ucafCollectionIndicator != null) {
        return v_ucafCollectionIndicator;
      }
    }

    if (
      p_evaluarreto != null &&
      (v_ucafCollectionIndicator == "" || v_ucafCollectionIndicator == null)
    ) {
      v_ucafCollectionIndicator =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .ucafCollectionIndicator;
      if (v_ucafCollectionIndicator != null) {
        return v_ucafCollectionIndicator;
      }
    }

    return "";
  };

  const getucafAutenticationData = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_ucafAutenticationData = "";
    if (p_validarretoeds != null) {
      v_ucafAutenticationData =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .ucafAuthenticationData;
      if (v_ucafAutenticationData != null) {
        return v_ucafAutenticationData;
      }
    }

    if (
      p_evaluarreto != null &&
      (v_ucafAutenticationData == "" || v_ucafAutenticationData == null)
    ) {
      v_ucafAutenticationData =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .ucafAuthenticationData;
      if (v_ucafAutenticationData != null) {
        return v_ucafAutenticationData;
      }
    }

    return "";
  };

  const getTarjetaTipoReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_Tipo = "";

    if (p_validarretoeds != null) {
      v_Tipo =
        p_validarretoeds.RespuestaGenerarReto.InformacionDePago.Tarjeta.Tipo;
      if (v_Tipo != null) {
        return v_Tipo;
      }
    }
    if (p_evaluarreto != null && (v_Tipo == "" || v_Tipo == null)) {
      v_Tipo =
        p_evaluarreto.RespuestaGenerarReto.InformacionDePago.Tarjeta.Tipo;
      if (v_Tipo != null) {
        return v_Tipo;
      }
    }

    return "";
  };

  const getcavvReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_cavv = "";

    if (p_validarretoeds != null) {
      v_cavv =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.cavv;
      if (v_cavv != null) {
        return v_cavv;
      }
    }
    if (p_evaluarreto != null && (v_cavv == "" || v_cavv == null)) {
      v_cavv =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion.cavv;
      if (v_cavv != null) {
        return v_cavv;
      }
    }
    return "";
  };

  const getEstadoReto = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_Estado = "";

    if (p_validarretoeds != null) {
      v_Estado = p_validarretoeds.RespuestaGenerarReto.Estado;
      if (v_Estado != null) {
        return v_Estado;
      }
    }

    if (p_evaluarreto != null && (v_Estado == "" || v_Estado == null)) {
      v_Estado = p_evaluarreto.RespuestaGenerarReto.Estado;
      if (v_Estado != null) {
        return v_Estado;
      }
    }

    return "";
  };

  const getspecificationVersion = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_specificationVersion = "";

    if (p_validarretoeds != null) {
      v_specificationVersion =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .specificationVersion;
      if (v_specificationVersion != null) {
        return v_specificationVersion;
      }
    }
    if (
      p_evaluarreto != null &&
      (v_specificationVersion == "" || v_specificationVersion == null)
    ) {
      v_specificationVersion =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .specificationVersion;
      if (v_specificationVersion != null) {
        return v_specificationVersion;
      }
    }

    return "";
  };

  const getdirectoryServerTransactionId = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_directoryServerTransactionId = "";

    if (p_validarretoeds != null) {
      v_directoryServerTransactionId =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .directoryServerTransactionId;
      if (v_directoryServerTransactionId != null) {
        return v_directoryServerTransactionId;
      }
    }
    if (
      p_evaluarreto != null &&
      (v_directoryServerTransactionId == "" ||
        v_directoryServerTransactionId == null)
    ) {
      v_directoryServerTransactionId =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .directoryServerTransactionId;
      if (v_directoryServerTransactionId != null) {
        return v_directoryServerTransactionId;
      }
    }
    return "";
  };

  const geteCommerceIndicator = (
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null
  ) => {
    let v_ecommerceIndicator = "";

    if (p_validarretoeds != null) {
      v_ecommerceIndicator =
        p_validarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
          .ecommerceIndicator;
      if (v_ecommerceIndicator != null) {
        return v_ecommerceIndicator;
      }
    }
    if (
      p_evaluarreto != null &&
      (v_ecommerceIndicator == "" || v_ecommerceIndicator == null)
    ) {
      v_ecommerceIndicator =
        p_evaluarreto.RespuestaGenerarReto.InformacionDeAutenticacion
          .ecommerceIndicator;
      if (v_ecommerceIndicator != null) {
        return v_ecommerceIndicator;
      }
    }

    return "";
  };

  const erraseCommaCharacter = (mount: any) => {
    return mount.replace(",", "").replace("-", "");
  };

  const importePagoMonedaLocal = (param1: any, param2: any) => {
    const param1Parse = Number.parseFloat(param1);

    const param2Parse = Number.parseFloat(param2);

    if (
      param1Parse &&
      param1Parse != null &&
      typeof param1Parse != "undefined" &&
      !Number.isNaN(param1Parse)
    ) {
      if (
        param2Parse &&
        param2Parse != null &&
        typeof param2Parse != "undefined" &&
        !Number.isNaN(param2Parse)
      ) {
        return param1Parse * param2Parse;
      } else {
        return param1Parse * 0;
      }
    } else {
      return 0 * param2Parse;
    }
  };

  const doValidacionesDatos = (p_card: ConsultarBilletera_Info) => {
    var retorno = true;
    if (p_card === null || typeof p_card === "undefined") {
      setStatus("ERROR");
      setMessage("Favor de seleccionar una tarjeta disponible");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      //alert("");
      retorno = false;
    } else {
      if (
        myInputCVV === "" ||
        myInputCVV === null ||
        !myInputCVV.match(/^\d+/)
      ) {
        setStatus("ERROR");
        setMessage("Favor de ingresar un cvv valido");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
        retorno = false;
      } else {
        if (otherQuantity.length === 0 && saldoAPagar === "0") {
          setStatus("ERROR");
          setMessage(
            "Su saldo es 0, favor de ingresar un valor en Otra Cantidad"
          );
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
          retorno = false;
        } else if (otherQuantity.length > 0 && !otherQuantity.match(/^\d+/)) {
          setStatus("ERROR");
          setMessage("Favor de ingresar un monto valido");
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
          retorno = false;
        } else {
          if (otherQuantity.length > 0 && otherQuantity.match(/^\d+/)) {
            retorno = validarMontosMinimosYMaximos(otherQuantity);
          }
          //SE VALIDA QUE EL MONTO SE AMYOR A 100
        }
      }
    }

    return retorno;
  };

  const muestraMensajeMontos = (p_mensaje: string) => {
    setStatus("ERROR");
    setMessage(p_mensaje);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const validarMontosMinimosYMaximos = (montoString: string) => {
    const montoFloat = Number.parseFloat(montoString);
    let pais = sessionStorage.getItem("PrimaryAccountCountry")!;

    if (pais === "Mexico") {
      if (montoFloat < 15.0) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 15");
        return false;
      } else if (montoFloat > 17000) {
        muestraMensajeMontos(
          "Favor de ingresar un monto menor o igual a 17000"
        );
        return false;
      }
    } else if (pais === "Costa Rica") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 540000) {
        muestraMensajeMontos(
          "Favor de ingresar un monto menor o igual a 540000"
        );
        return false;
      }
    } else if (pais === "Guatemala") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 7824) {
        muestraMensajeMontos("Favor de ingresar un monto menor o igual a 7824");
        return false;
      }
    } else if (pais === "Honduras") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 1000) {
        muestraMensajeMontos("Favor de ingresar un monto menor o igual a 1000");
        return false;
      }
    } else if (pais === "Nicaragua") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 1000) {
        muestraMensajeMontos("Favor de ingresar un monto menor o igual a 1000");
        return false;
      }
    } else if (pais === "Panama") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 1000) {
        muestraMensajeMontos("Favor de ingresar un monto menor o igual a 1000");
        return false;
      }
    } else if (pais === "Republica Dominicana") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 57408.6) {
        muestraMensajeMontos(
          "Favor de ingresar un monto menor o igual a 57408.60"
        );
        return false;
      }
    } else if (pais === "El Salvador") {
      if (montoFloat < 3) {
        muestraMensajeMontos("Favor de ingresar un monto mayor o igual a 3");
        return false;
      } else if (montoFloat > 1000) {
        muestraMensajeMontos("Favor de ingresar un monto menor o igual a 1000");
        return false;
      }
    }

    return true;
  };

  const doValidacionesLogitudes = (p_card: ConsultarBilletera_Info) => {
    var retorno = true;
    if (p_card.TipoTarjeta === "003") {
      if (myInputCVV.length != 4) {
        setStatus("ERROR");
        setMessage("La longitud del CVV para American Express son 4 digitos");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
        retorno = false;
      }
    } else {
      //VISA MASTER CARD
      if (myInputCVV.length != 3) {
        setStatus("ERROR");
        setMessage("La longitud del CVV debe de ser 3 digitos");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
        retorno = false;
      }
    }

    return retorno;
  };

  function nombrepais(param: string) {
    if (param === "MX") {
      return "MEX";
    } else if (param === "CR") {
      return "CRICA";
    } else if (param === "GT") {
      return "GT";
    } else if (param === "HN") {
      return "HON";
    } else if (param === "NI") {
      return "NIC";
    } else if (param === "PA") {
      return "PAN";
    } else if (param === "DO") {
      return "DOM";
    } else if (param === "SV") {
      return "SAL";
    }
  }

  function horaFormateada() {
    var momentoActual = new Date();
    var hora = momentoActual.getHours();
    var minuto = momentoActual.getMinutes();
    var segundo = momentoActual.getSeconds();

    let horaImprimible = hora + "" + minuto + "" + segundo;
    return horaImprimible;
  }

  function fechaFormateada() {
    var today = new Date();
    var day = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();
    let fechaImprimible =
      formatDAYMONTHYEAR("anho", year.toString()) +
      "" +
      formatDAYMONTHYEAR("mes", month.toString()) +
      "" +
      formatDAYMONTHYEAR("dia", day.toString());
    return fechaImprimible;
  }

  const formatDAYMONTHYEAR = (nombre: string, valor: string) => {
    if (nombre === "dia" || nombre === "mes") {
      if (valor.length == 1) {
        return "0" + valor;
      } else {
        return valor;
      }
    } else if (nombre === "anho") {
      return valor.substring(2, 4);
    }
  };

  function handleChangeForCvv(event: any) {
    const re = /^[0-9\b]+$/;
    setCleanCVV(false);
    if (event.target.value === "" || re.test(event.target.value)) {
      setMyInputCVV(event.target.value);
    }
  }

  function handleChangeForNewQuantity(event: any) {
    const re = /^\$?\d+(,\d{3})*(\.\d*)?$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setOtherQuantity(event.target.value);
    }
  }

  const getCvvPlaceholder = (ptodaslastarjetas: ConsultarBilletera_Info[]) => {
    if (ptodaslastarjetas != null && ptodaslastarjetas.length > 0) {
      if (ptodaslastarjetas[initialPositionArray].TipoTarjeta === "003") {
        return "****";
      } else {
        return "***";
      }
    } else {
      return "***";
    }
  };

  const loadingScriptDFP = async (p_card: ConsultarBilletera_Info) => {
    const {
      REACT_APP_URL_DEVICE_FINGERPRINT,
      REACT_APP_URL_DEVICE_FINGERPRINT_BODY,
    } = process.env;
    const urlHeadDfp = REACT_APP_URL_DEVICE_FINGERPRINT ?? "";
    const urlBodyDfp = REACT_APP_URL_DEVICE_FINGERPRINT_BODY ?? "";
    const scriptsHead = document.head.getElementsByTagName("script");
    let scriptHeadDfp = scriptsHead[0];

    let idx = 0;
    let existeScript: boolean = false;
    //se hace el recorrido de todos los script que estan sobre head O hasta que se encuentre el de DFP
    while (!existeScript && idx < scriptsHead.length) {
      const attr: string | null = scriptsHead[idx].getAttribute("src");

      existeScript = attr?.includes(urlHeadDfp) ?? false;
      if (existeScript) {
        scriptHeadDfp = scriptsHead[idx];
        idx = scriptsHead.length;
      }
      idx++;
    }

    doDeterminarComercio(p_card).then((determinarComercioRet) => {
      const paramOrgIDdfp =
        "org_id=" +
        determinarComercioRet?.BilleteraComercioCollection.BilleteraComercio[0]
          .dfpOr;
      const paramSesionId =
        "session_id=" +
        determinarComercioRet?.BilleteraComercioCollection.BilleteraComercio[0]
          .mid +
        sessionIdDFP;
      const srcHeadDfp: string =
        urlHeadDfp + paramOrgIDdfp + "&" + paramSesionId;

      const srcBodyDfp: string =
        urlBodyDfp + paramOrgIDdfp + "&" + paramSesionId;
      //siempre que no se encuentre presente el script de DFP
      if (!existeScript) {
        const dfScript = document.createElement("script");
        dfScript.setAttribute("type", "text/javascript");
        dfScript.setAttribute("src", srcHeadDfp);
        //se agrega el script como primer elemento de head
        document.head.insertAdjacentElement("afterbegin", dfScript);
        const noscriptDfp = document.createElement("noscript");
        const iframe = document.createElement("iframe");
        iframe.setAttribute("id", "iFrameDfp");
        iframe.setAttribute(
          "style",
          "width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;"
        );
        iframe.setAttribute("src", srcBodyDfp);
        noscriptDfp.prepend(iframe);

        //se agrega el noscript como primer elemento de body
        document.body.insertAdjacentElement("afterbegin", noscriptDfp);
      } else {
        scriptHeadDfp.setAttribute("src", srcHeadDfp);
        const iFrameExiste = document.getElementById("iFrameDfp");
        if (iFrameExiste) {
          iFrameExiste.setAttribute("src", srcBodyDfp);
        }
      }
    });
  };

  const formatDateToString = (date: Date, format: string = "DD/MM/YY") => {
    // obtener mes, día del mes, año, hora
    var moment = require("moment");
    var now = moment(date);
    return now.format(format);
  };

  const doGenerarJWTokenEBS = async (
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_identificadorunicopago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_tarjeta: ConsultarBilletera_Info
  ) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const GwGenerarJWTokenEBSEntrada: GwGenerarJWTokenEBS_Entrada =
        builtGwGenerarJWTokenEBSEntrada(
          p_determinarcomercio?.BilleteraComercioCollection.BilleteraComercio[0]
            .mid!,
          p_identificadorunicopago?.Salida_Process.IdPagoSKY!,
          p_tarjeta.PaymentInstrument
        );
      let GwGenerarJWTokenEBSParametros = GwGenerarJWTokenEBS_Parametros(
        GwGenerarJWTokenEBSEntrada
      );
      let GwGenerarJWTokenEBSRespuesta: GwGenerarJWTokenEBS_Respuesta =
        await ConsultaWS(GwGenerarJWTokenEBSParametros);

      if (
        GwGenerarJWTokenEBSRespuesta.EBMHeaderResponse &&
        GwGenerarJWTokenEBSRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        GwGenerarJWTokenEBSRespuesta.EBMHeaderResponse.ErrorTecnico.code === "0"
      ) {
        return GwGenerarJWTokenEBSRespuesta;
      } else {
        return errorAndReturnNull(GwGenerarJWTokenEBSRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const errorAndReturnNull = (p_errorobject: any) => {
    console.error("Error al ejecutar el servicio ");
    console.error(p_errorobject);
    setIsLoading(false);
    setIsPaymentPrcessOn(false);
    return null;
  };

  const doEjecutarDeviceDataCollectionIFrame = (
    p_generarJwToken: GwGenerarJWTokenEBS_Respuesta,
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_identificadorunicopago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_tarjeta: ConsultarBilletera_Info,
    p_consultarbines: ConsultarBines_Respuesta,
    p_EvaluarRiesgo: EvaluarRiesgo_Respuesta
  ) => {
    var elemDiv = document.createElement("div");

    const cardinalCollectionIFrame = document.createElement("iframe");
    cardinalCollectionIFrame.setAttribute("id", "cardinal_collection_iframe");
    cardinalCollectionIFrame.setAttribute("style", "display:none;");
    cardinalCollectionIFrame.setAttribute("name", "collectionIframe");
    cardinalCollectionIFrame.setAttribute("height", "10");
    cardinalCollectionIFrame.setAttribute("width", "10");

    const cardinalCollectionForm = document.createElement("form");
    cardinalCollectionForm.setAttribute("id", "cardinal_collection_form");
    cardinalCollectionForm.setAttribute("method", "POST");
    cardinalCollectionForm.setAttribute("target", "collectionIframe");
    cardinalCollectionForm.setAttribute(
      "action",
      p_generarJwToken.RespuestaGenerarJWToken
        .InformacionDeAutenticacionDeInvocacion.UrlParaCollecionDeDatos
    );

    const cardinalCollectionInput = document.createElement("input");
    cardinalCollectionInput.setAttribute(
      "id",
      "cardinal_collection_form_input"
    );
    cardinalCollectionInput.setAttribute("type", "hidden");
    cardinalCollectionInput.setAttribute("name", "JWT");
    cardinalCollectionInput.setAttribute(
      "value",
      p_generarJwToken.RespuestaGenerarJWToken
        .InformacionDeAutenticacionDeInvocacion.accessToken
    );

    elemDiv.appendChild(cardinalCollectionIFrame);
    cardinalCollectionForm.appendChild(cardinalCollectionInput);
    elemDiv.appendChild(cardinalCollectionForm);

    document.body.appendChild(elemDiv);

    cardinalCollectionForm.submit();

    window.addEventListener(
      "message",
      function (event) {
        const { REACT_APP_CENTINEL_API } = process.env;
        if (event.origin === REACT_APP_CENTINEL_API) {
          let respuestaCardinalCommer = JSON.parse(event.data);

          setTimeout(() => {
            doEvaluarReto3DS(
              p_determinarcomercio,
              p_identificadorunicopago,
              p_tarjeta,
              respuestaCardinalCommer.SessionId
            ).then((EvaluarReto3DSRet) => {
              if (
                EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado ===
                  "CHALLENGE" ||
                EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado ===
                  "CHALENGE"
              ) {
                doEjecutarStepupIframe(
                  EvaluarReto3DSRet,
                  p_determinarcomercio,
                  p_identificadorunicopago,
                  p_tarjeta,
                  p_consultarbines,
                  p_EvaluarRiesgo
                );
              } else if (
                EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado ===
                "ACCEPT"
              ) {
                doProcesarTransaccionDMEBS(
                  p_determinarcomercio,
                  p_identificadorunicopago,
                  null,
                  EvaluarReto3DSRet,
                  false,
                  p_EvaluarRiesgo
                ).then((ProcesarTransaccionDMRet) => {
                  if (ProcesarTransaccionDMRet != null) {
                    doActualizarBilletera(
                      null,
                      p_tarjeta,
                      null,
                      EvaluarReto3DSRet,
                      false,
                      true
                    ).then((ActualizarBilleteraRet) => {
                      if (ActualizarBilleteraRet != null) {
                        resumeFlowAfterConsultingExchangeRate(
                          p_tarjeta,
                          p_determinarcomercio,
                          p_consultarbines,
                          p_identificadorunicopago,
                          null,
                          EvaluarReto3DSRet,
                          null
                        );
                      } else {
                        console.error(
                          "ActualizarBilleteraRet nulo ",
                          ActualizarBilleteraRet
                        );
                        redirectToError();
                      }
                    });
                  } else {
                    console.error(
                      "ProcesarTransaccionDMRet nulo ",
                      ProcesarTransaccionDMRet
                    );
                    redirectToError();
                  }
                });
              } else if (
                EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado ===
                "REJECT"
              ) {
                console.error(
                  "EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado === REJECT"
                );
                redirectToError();
              } else {
                console.error(
                  "EvaluarReto3DSRet?.RespuestaGenerarReto.EstadoSky.Estado === UNKNOWN"
                );
                redirectToError();
              }
            });
          }, 10000);
        }
      },
      false
    );
  };

  const redirectToError = () => {
    setIsLoading(false);
    setIsPaymentPrcessOn(false);
    setChangeCardClicked(false);
    setConfirmPaymentClicked(false);
    setInitialPositionArray(0);
    setInitialPositionArrayBKP(0);
    setMyInputCVV("");
    setOtherQuantity("");
    let Mensaje =
      "Error en el flujo, favor de revisar consola del navegador para detalle";
    props.onHide({ action: "error" }, Mensaje);
  };

  const resumeFlowAfterConsultingExchangeRate = (
    p_consultarbilletera: ConsultarBilletera_Info,
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_consultarbines: ConsultarBines_Respuesta,
    p_identificadorpago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_validarretoeds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarreto: GwEvaluarReto3DSEBS_Respuesta | null,
    p_transactionIdFromBank: string | null
  ) => {
    //7 tipo de cambio
    doConsultarTipoCambio(p_consultarbilletera).then(
      (consultartipocambioret) => {
        if (consultartipocambioret != null) {
          //8 ConsultarServiciosCuenta
          doConsultarServiciosCuentaRest().then(
            (consultarServicioCUentaRet) => {
              //9 orquestar proceso pago
              doOrquestarPago(
                p_determinarcomercio!,
                p_consultarbines!,
                p_identificadorpago!,
                consultartipocambioret!,
                doValidareLoginUser(consultarServicioCUentaRet!),
                p_consultarbilletera,
                p_validarretoeds,
                p_evaluarreto,
                p_transactionIdFromBank
              ).then((OrquestarPagoRet) => {
                if (OrquestarPagoRet != null) {
                  setIsLoading(false);
                  setIsPaymentPrcessOn(false);
                  //var orquestarProcesoPagoResponseVar = orquestarProcesoPagoResponse as any;
                  let Mensaje =
                    OrquestarPagoRet!.EBMHeaderResponse.ErrorNegocio
                      .DescripcionError +
                    ", Numero de Autorización: " +
                    OrquestarPagoRet!.RespuestaPagoTarjeta
                      .numeroAutorizacionPago +
                    " Numero de Referencia de Pago: " +
                    OrquestarPagoRet!.RespuestaPagoTarjeta.numeroReferenciaPago;
                  setChangeCardClicked(false);
                  setConfirmPaymentClicked(false);
                  setInitialPositionArray(0);
                  setInitialPositionArrayBKP(0);
                  setMyInputCVV("");
                  setOtherQuantity("");
                  props.onHide({ action: "terminar" }, Mensaje);
                } else {
                  console.error("OrquestarPagoRet nulo", OrquestarPagoRet);
                  redirectToError();
                }
              });
            }
          );
        } else {
          console.error("consultartipocambioret nulo ", consultartipocambioret);
          redirectToError();
        }
      }
    );
    //7 tipo de cambio
  };

  const doEvaluarReto3DS = async (
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_identificadorunicopago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_tarjeta: ConsultarBilletera_Info,
    p_sessionid: string
  ) => {
    try {
      var cantidadNueva = !(otherQuantity.length < 1)
        ? otherQuantity
        : saldoAPagar;
      //----------------------------------------------------------------------------------------------------------------------------
      var userLang = navigator.language;
      var height = window.innerHeight;
      var width = window.innerWidth;
      var date = new Date();
      var httpBrowserTimeDifference = date.getTimezoneOffset();
      var dispositivoInfo: DispositivoInfo = builtDispositivoInfo(
        `${window.screen.colorDepth}`,
        "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8", //p_httpContenidoAceptado: string,
        `${window.navigator.javaEnabled()}`,
        `${true}`,
        userLang,
        height.toString(),
        width.toString(),
        httpBrowserTimeDifference.toString(), //p_httpTiempoDeDiferencia: string,
        sessionStorage.getItem("IPv4")!,
        navigator.userAgent
      );
      const { REACT_APP_ENROLLMENT_LISTENER_PROXY } = process.env;
      const GwEvaluarReto3DSEBSEntrada: GwEvaluarReto3DSEBS_Entrada =
        builtGwEvaluarReto3DSEBSInput(
          p_determinarcomercio.BilleteraComercioCollection.BilleteraComercio[0]
            .mid,
          p_identificadorunicopago.Salida_Process.IdPagoSKY,
          cantidadNueva,
          getMoneda(`${sessionStorage.getItem("PrimaryAccountCountry")!}`),
          p_tarjeta.PaymentInstrument,
          validarNulosYIndefinidios(sessionStorage.getItem("TelMovil")),
          "S",
          p_sessionid,
          REACT_APP_ENROLLMENT_LISTENER_PROXY!,
          //"http://localhost:8580/enrollment-return/v1/listener",
          "Browser",
          dispositivoInfo,
          p_tarjeta.TipoBin == "CREDITO" ? "CR" : "DB",
          "SVC"
        );
      let GwEvaluarReto3DSEBSParametros = GwEvaluarReto3DSEBS_Parametros(
        GwEvaluarReto3DSEBSEntrada
      );

      let GwEvaluarReto3DSEBSRespuesta: GwEvaluarReto3DSEBS_Respuesta =
        await ConsultaWS(GwEvaluarReto3DSEBSParametros);

      if (
        GwEvaluarReto3DSEBSRespuesta.EBMHeaderResponse &&
        GwEvaluarReto3DSEBSRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        GwEvaluarReto3DSEBSRespuesta.EBMHeaderResponse.ErrorTecnico.code === "0"
      ) {
        return GwEvaluarReto3DSEBSRespuesta;
      } else {
        return errorAndReturnNull(GwEvaluarReto3DSEBSRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const getMoneda = (p_primaryaccountcountry: any) => {
    if (p_primaryaccountcountry === "Mexico") {
      return "MXN";
    } else if (p_primaryaccountcountry === "Costa Rica") {
      return "CRC";
    } else if (p_primaryaccountcountry === "Guatemala") {
      return "GTQ";
    } else if (p_primaryaccountcountry === "Honduras") {
      return "HNL";
    } else if (p_primaryaccountcountry === "Nicaragua") {
      return "NIO";
    } else if (p_primaryaccountcountry === "Panama") {
      return "USD";
    } else if (p_primaryaccountcountry === "Republica Dominicana") {
      return "DOP";
    } else if (p_primaryaccountcountry === "El Salvador") {
      return "USD";
    } else {
      return "MXN";
    }
  };

  const doEjecutarStepupIframe = (
    p_valuarretoeds: GwEvaluarReto3DSEBS_Respuesta,
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_identificadorunicopago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_tarjeta: ConsultarBilletera_Info,
    p_consultarbines: ConsultarBines_Respuesta,
    p_EvaluarRiesgo: EvaluarRiesgo_Respuesta
  ) => {
    setIsLoading(false);

    //var elemDiv = document.createElement("div");

    const StepupIFrame = document.createElement("iframe");
    StepupIFrame.setAttribute("id", "step-up-iframeid");
    StepupIFrame.setAttribute("name", "step-up-iframe");
    StepupIFrame.setAttribute("height", "400");
    StepupIFrame.setAttribute("width", "400");

    const StepupForm = document.createElement("form");
    StepupForm.setAttribute("id", "step-up-form");
    StepupForm.setAttribute("method", "post");
    StepupForm.setAttribute("target", "step-up-iframe");
    StepupForm.setAttribute(
      "action",
      p_valuarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion.stepUpUrl
    );

    const StepupInputJWT = document.createElement("input");
    StepupInputJWT.setAttribute("id", "cardinal_collection_form_input");
    StepupInputJWT.setAttribute("type", "hidden");
    StepupInputJWT.setAttribute("name", "JWT");
    StepupInputJWT.setAttribute(
      "value",
      p_valuarretoeds.RespuestaGenerarReto.InformacionDeAutenticacion
        .accessToken
    );

    const StepupInputMD = document.createElement("input");
    StepupInputMD.setAttribute("id", "input-id");
    StepupInputMD.setAttribute("type", "hidden");
    StepupInputMD.setAttribute("name", "MD");
    StepupInputMD.setAttribute("value", "");

    const elemDiv = document.getElementById("DivForChallenge");

    elemDiv!.appendChild(StepupIFrame);
    StepupForm.appendChild(StepupInputJWT);
    StepupForm.appendChild(StepupInputMD);
    elemDiv!.appendChild(StepupForm);

    StepupForm.submit();

    setEventoDisparado(false);
    setTimeout(() => {
      if (!eventoDisparado) {
        eliminarElementoHtml("step-up-iframeid");
        eliminarElementoHtml("cardinal_collection_form_input");
        eliminarElementoHtml("input-id");
        eliminarElementoHtml("step-up-form");
        doValidarReto3DSEBS(
          p_valuarretoeds,
          p_determinarcomercio,
          p_identificadorunicopago,
          p_tarjeta,
          ""
        ).then((ValidarReto3DSRET) => {
          console.error("ProcesarTransaccionDMRet nulo ", ValidarReto3DSRET);
          redirectToError();
        });
      }
    }, 600000);

    window.addEventListener(
      "message",
      function (event) {
        const { REACT_APP_ENROLLMENT_LISTENER_PROXY_HOST } = process.env;
        if (event.origin === REACT_APP_ENROLLMENT_LISTENER_PROXY_HOST) {
          eliminarElementoHtml("step-up-iframeid");
          eliminarElementoHtml("cardinal_collection_form_input");
          eliminarElementoHtml("input-id");
          eliminarElementoHtml("step-up-form");

          setIsLoading(true);
          let respuestaEnrollmentReturn = event.data;

          let transactionIdFromBank = respuestaEnrollmentReturn.transactionId;

          doValidarReto3DSEBS(
            p_valuarretoeds,
            p_determinarcomercio,
            p_identificadorunicopago,
            p_tarjeta,
            transactionIdFromBank
          ).then((ValidarReto3DSRET) => {
            if (ValidarReto3DSRET != null) {
              doProcesarTransaccionDMEBS(
                p_determinarcomercio,
                p_identificadorunicopago,
                ValidarReto3DSRET,
                p_valuarretoeds,
                true,
                p_EvaluarRiesgo
              ).then((ProcesarTransaccionDMRet) => {
                if (ProcesarTransaccionDMRet != null) {
                  doActualizarBilletera(
                    null,
                    p_tarjeta,
                    null,
                    p_valuarretoeds,
                    false,
                    true
                  ).then((ActualizarBilleteraRet) => {
                    if (ActualizarBilleteraRet != null) {
                      resumeFlowAfterConsultingExchangeRate(
                        p_tarjeta,
                        p_determinarcomercio,
                        p_consultarbines,
                        p_identificadorunicopago,
                        ValidarReto3DSRET,
                        p_valuarretoeds,
                        transactionIdFromBank
                      );
                    } else {
                      console.error(
                        "ActualizarBilleteraRet nulo ",
                        ActualizarBilleteraRet
                      );
                      redirectToError();
                    }
                  });
                } else {
                  console.error(
                    "ProcesarTransaccionDMRet nulo ",
                    ProcesarTransaccionDMRet
                  );
                  redirectToError();
                }
              });
            } else {
              console.error("ValidarReto3DSRET nulo ", ValidarReto3DSRET);
              redirectToError();
            }
          });
        }
      },
      false
    );
  };

  const eliminarElementoHtml = (p_nombre: string) => {
    const elemento = document.getElementById(p_nombre);
    if (elemento != null) {
      elemento.remove();
    }
  };

  const doProcesarTransaccionDMEBS = async (
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_generaridentificador: GenerarIdentificadorUnicoDePago_Respuesta,
    p_validarreto3ds: GwValidarReto3DSEBS_Respuesta | null,
    p_evaluarReto: GwEvaluarReto3DSEBS_Respuesta,
    p_stepupshow: boolean,
    p_EvaluarRiesgo: EvaluarRiesgo_Respuesta
  ) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const GwProcesarTransaccionDMEBSEntrada: GwProcesarTransaccionDMEBS_Entrada =
        builtGwProcesarTransaccionDMEBSInput(
          p_determinarcomercio.BilleteraComercioCollection.BilleteraComercio[0]
            .mid,
          p_generaridentificador.Salida_Process.IdPagoSKY,
          p_stepupshow
            ? p_validarreto3ds!.RespuestaGenerarReto.EstadoSky.Estado
            : p_evaluarReto.RespuestaGenerarReto.EstadoSky.Estado,
          p_EvaluarRiesgo.TransaccionId,
          ""
        );
      let GwProcesarTransaccionDMEBSParametros =
        GwProcesarTransaccionDMEBS_Parametros(
          GwProcesarTransaccionDMEBSEntrada
        );
      let GwProcesarTransaccionDMEBSRespuesta: GwProcesarTransaccionDMEBS_Respuesta =
        await ConsultaWS(GwProcesarTransaccionDMEBSParametros);

      if (
        GwProcesarTransaccionDMEBSRespuesta.EBMHeaderResponse &&
        GwProcesarTransaccionDMEBSRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        GwProcesarTransaccionDMEBSRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "0"
      ) {
        return GwProcesarTransaccionDMEBSRespuesta;
      } else {
        return errorAndReturnNull(GwProcesarTransaccionDMEBSRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const doValidarReto3DSEBS = async (
    p_EvaluarReto3DSEBS: GwEvaluarReto3DSEBS_Respuesta,
    p_determinarcomercio: DeterminarComercio_Respuesta,
    p_identificadorunicopago: GenerarIdentificadorUnicoDePago_Respuesta,
    p_tarjeta: ConsultarBilletera_Info,
    p_transactionid: string
  ) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      var cantidadNueva = !(otherQuantity.length < 1)
        ? otherQuantity
        : saldoAPagar;
      const GwValidarReto3DSEBSEntrada: GwValidarReto3DSEBS_Entrada =
        builtGwValidarReto3DSEBSInput(
          "S",
          p_transactionid != ""
            ? p_transactionid
            : p_EvaluarReto3DSEBS.RespuestaGenerarReto
                .InformacionDeAutenticacion.authenticationTransactionId,
          validarNulosYIndefinidios(sessionStorage.getItem("TelMovil")),
          p_tarjeta.PaymentInstrument,
          cantidadNueva,
          getMoneda(`${sessionStorage.getItem("PrimaryAccountCountry")!}`),
          p_determinarcomercio.BilleteraComercioCollection.BilleteraComercio[0]
            .mid,
          p_identificadorunicopago.Salida_Process.IdPagoSKY
        );
      let GwValidarReto3DSEBSParametros = GwValidarReto3DSEBS_Parametros(
        GwValidarReto3DSEBSEntrada
      );

      let GwValidarReto3DSEBSRespuesta: GwValidarReto3DSEBS_Respuesta =
        await ConsultaWS(GwValidarReto3DSEBSParametros);

      if (
        GwValidarReto3DSEBSRespuesta.EBMHeaderResponse &&
        GwValidarReto3DSEBSRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
          "ok" &&
        GwValidarReto3DSEBSRespuesta.EBMHeaderResponse.ErrorTecnico.code === "0"
      ) {
        return GwValidarReto3DSEBSRespuesta;
      } else {
        return errorAndReturnNull(GwValidarReto3DSEBSRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      return errorAndReturnNull(error);
    }
  };

  const handleCloseModalReto = () => {};

  const handleCloseModalPago = () => {
    setIsLoading(false);
    setIsPaymentPrcessOn(false);
    setChangeCardClicked(false);
    setConfirmPaymentClicked(false);
    setInitialPositionArray(0);
    setInitialPositionArrayBKP(0);
    setMyInputCVV("");
    setOtherQuantity("");
    props.onHide();
  };

  const validarNulosYIndefinidios = (param: any) => {
    var retorno: string = "";
    if (param != null && typeof param != "undefined") {
      retorno = param;
    } else {
      retorno = "";
    }

    return retorno;
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={handleCloseModalPago}
      >
        <Modal.Header
          closeButton
          className={styles["modalHeaderConfirmacion"]}
        ></Modal.Header>
        <Modal.Body>
          <Row className={styles["alertContainer"]}>
            <Col className={styles["messageStyle"]}>
              <ConfirmMessage2
                status={status}
                message={message}
                showAlert={showAlert}
                paddingLeft="cvv4VerificaPago"
              />
            </Col>
          </Row>

          {!confirmPaymentClicked ? (
            <Container>
              <Row
                style={{ paddingBottom: "5px" }}
                className={styles["alignCenterCenterColumn4title"]}
              >
                <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                  <span
                    className={styles["fontModalTitlePagar"] + " gris-oscuro"}
                  >
                    Verifica tu recarga
                  </span>
                </Col>
              </Row>
              <Row
                style={{ paddingBottom: "10px" }}
                className={styles["alignCenterCenterColumn"]}
              >
                <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                  <span className={styles["fontSizeAddCard"] + " gris-oscuro"}>
                    Estás por recargar{" "}
                    {!(otherQuantity.length < 1) ? (
                      <span style={{ fontWeight: "600" }}>
                        ${otherQuantity},
                      </span>
                    ) : (
                      <span style={{ fontWeight: "600" }}>${saldoAPagar},</span>
                    )}{" "}
                    de la factura del mes{" "}
                    <span style={{ fontWeight: "600" }}>{fechaLimite}</span>
                  </span>
                </Col>
              </Row>
              <Row className={styles["pb4ChangeCard"]}>
                {!changeCardClicked ? (
                  <Col
                    xs={{ span: 12, offset: 0 }}
                    lg={{ span: 6, offset: 2 }}
                    className={styles["alignCenterCenterColumn"]}
                  >
                    <CardGallery
                      allItCards={allItCards}
                      oldCardValue={initialPositionArray}
                      newCardValue={(respuesta: number) => {
                        setInitialPositionArray(respuesta);

                        //setGallerySelectedCard(allItCards[respuesta]);
                      }}
                      origen={origen}
                      changeCardClicked={changeCardClicked}
                    />
                    <Button
                      variant="link"
                      type="submit"
                      className={styles["linkFontEditar"]}
                      onClick={() => {
                        setChangeCardClicked(true);
                        setInitialPositionArrayBKP(initialPositionArray);
                        setInitialPositionArray(0);
                      }}
                      style={{ width: "100%" }}
                    >
                      Cambiar tarjeta
                    </Button>
                  </Col>
                ) : (
                  <CardGallery
                    allItCards={allItCards}
                    oldCardValue={initialPositionArray}
                    newCardValue={(respuesta: number) => {
                      setInitialPositionArray(respuesta);
                      //setGallerySelectedCard(allItCards[respuesta]);
                    }}
                    origen={origen}
                    changeCardClicked={changeCardClicked}
                  />
                )}
                {!changeCardClicked ? (
                  <Col
                    xs={{ span: 12 }}
                    lg={{ span: 2 }}
                    className={styles["centerOtraCantidad"]}
                  >
                    <Form.Group>
                      <Form.Label
                        className={
                          styles["font-size-label-form"] +
                          " gris-oscuro " +
                          styles["select"]
                        }
                      >
                        Otra cantidad
                      </Form.Label>

                      <Form.Control
                        className={styles["styleInputText"]}
                        type="text"
                        placeholder="00.00"
                        value={otherQuantity}
                        onChange={handleChangeForNewQuantity}
                      />
                    </Form.Group>
                    <br></br>
                    <Form.Group>
                      <Form.Label
                        className={
                          styles["font-size-label-form"] +
                          " gris-oscuro " +
                          styles["select4cvv"]
                        }
                      >
                        CVV
                      </Form.Label>

                      <Form.Control
                        className={styles["styleInputText"]}
                        type="password"
                        placeholder={getCvvPlaceholder(allItCards)}
                        pattern="[0-9]"
                        inputMode="numeric"
                        minLength={3}
                        maxLength={4}
                        value={myInputCVV}
                        onChange={handleChangeForCvv}
                      />
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
              <Row
                style={{ paddingBottom: "5px" }}
                className={styles["alignCenterCenterColumn4Pay"]}
              >
                <Col xs={{ span: 12 }} lg={{ span: 3 }}>
                  <div id="DivForChallenge"></div>
                  {isLoading ? <LoadingSpinner /> : ""}
                  {!changeCardClicked ? (
                    <Button
                      className={styles["buttonBlueContinue"]}
                      style={{ width: "100%" }}
                      onClick={() => {
                        doConfirmPaymentCard(allItCards[initialPositionArray]);
                      }}
                    >
                      Recargar
                    </Button>
                  ) : (
                    <Button
                      className={styles["buttonBlueContinue"]}
                      style={{ width: "100%" }}
                      onClick={() => {
                        setChangeCardClicked(false);
                      }}
                    >
                      Seleccionar
                    </Button>
                  )}
                </Col>
              </Row>
              <Row className={styles["alignCenterCenterColumn"]}>
                <Col md={{ span: 3 }}>
                  {!changeCardClicked ? (
                    <Button
                      variant="link"
                      type="submit"
                      className={styles["linkFontEditar"]}
                      onClick={() => {
                        setChangeCardClicked(false);
                        setConfirmPaymentClicked(false);
                        setInitialPositionArray(0);
                        setInitialPositionArrayBKP(0);
                        setMyInputCVV("");
                        setOtherQuantity("");
                        props.onHide({ action: "cancelar" }, "");
                      }}
                      style={{ width: "100%" }}
                    >
                      Cancelar
                    </Button>
                  ) : (
                    <Button
                      variant="link"
                      type="submit"
                      className={styles["linkFontEditar"]}
                      onClick={() => {
                        setInitialPositionArray(initialPositionArrayBKP);
                        setChangeCardClicked(false);
                      }}
                      style={{ width: "100%" }}
                    >
                      Regresar
                    </Button>
                  )}
                </Col>
              </Row>
            </Container>
          ) : (
            <Container>
              <Row
                style={{ paddingBottom: "10px" }}
                className={styles["alignCenterCenterColumn"]}
              >
                <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                  <span
                    className={styles["fontModalTitlePagar"] + " gris-oscuro"}
                  >
                    Confirmar Recarga
                  </span>
                </Col>
              </Row>
              <Row
                style={{ paddingBottom: "10px" }}
                className={styles["alignCenterCenterColumn"]}
              >
                <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                  <span className={styles["fontSizeAddCard"] + " gris-oscuro"}>
                    Recuerde que el cargo a su tarjeta se realiza en moneda
                    local
                  </span>
                </Col>
              </Row>
              {sessionStorage.getItem("esCuentaCorporativa") === "V" ? (
                sessionStorage.getItem("esCuentaCorporativaJerarquia") ===
                "false" ? (
                  <Row
                    style={{ paddingBottom: "10px" }}
                    className={styles["alignCenterCenterColumn"]}
                  >
                    <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                      <span
                        className={styles["fontSizeAddCard"] + " gris-oscuro"}
                      >
                        Para la cuenta: {sessionStorage.getItem("cuenta")}
                      </span>
                    </Col>
                  </Row>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              <Row className={styles["alignCenterCenterColumn4TotalPagar"]}>
                <Col
                  xs={{ span: 12 }}
                  lg={{ span: 2 }}
                  className={styles["centerLogoCreditCard"]}
                >
                  <Form.Group className={styles["confirmPaymentInputText"]}>
                    <Form.Label>Total a recargar:</Form.Label>

                    <Form.Control
                      type="text"
                      disabled
                      value={
                        !(otherQuantity.length < 1)
                          ? otherQuantity
                          : saldoAPagar
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className={styles["alignCenterCenterColumn4TotalPagar"]}>
                <Col
                  xs={{ span: 12 }}
                  lg={{ span: 2 }}
                  className={styles["centerLogoCreditCard"]}
                >
                  <Form.Group className={styles["confirmPaymentInputText"]}>
                    <Form.Label>Tarjeta:</Form.Label>

                    <Form.Control
                      type="text"
                      disabled
                      value={allItCards[initialPositionArray].MaskedPan}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row
                style={{ padding: "15px" }}
                className={styles["alignCenterCenterColumn"]}
              >
                <Col xs={{ span: 12 }} lg={{ span: 3 }}>
                  <div id="DivForChallenge"></div>
                  {isLoading ? <LoadingSpinner /> : ""}

                  <Button
                    disabled={isPaymentPrcessOn}
                    className={styles["buttonBlueContinue"]}
                    style={{ width: "100%" }}
                    onClick={() => {
                      doPaymentCard(allItCards[initialPositionArray]);
                    }}
                  >
                    Recargar
                  </Button>
                </Col>
              </Row>
              <Row className={styles["alignCenterCenterColumn"]}>
                <Col md={{ span: 3 }}>
                  <Button
                    disabled={isPaymentPrcessOn}
                    variant="link"
                    type="submit"
                    className={styles["linkFontEditar"]}
                    onClick={() => {
                      setConfirmPaymentClicked(false);
                    }}
                    style={{ width: "100%" }}
                  >
                    Regresar
                  </Button>
                </Col>
              </Row>
            </Container>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalReto}
        onHide={handleCloseModalReto}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className={styles["modalHeaderConfirmacion"]}
        ></Modal.Header>
        <Modal.Body>
          <Container>
            <Row
              style={{ paddingBottom: "5px" }}
              className={styles["alignCenterCenterColumn4title"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <span
                  className={styles["fontModalTitlePagar"] + " gris-oscuro"}
                >
                  Reto
                </span>
              </Col>
            </Row>
            <Row
              style={{ paddingBottom: "10px" }}
              className={styles["alignCenterCenterColumn"]}
            >
              <Col md={{ span: 12 }} style={{ textAlign: "center" }}>
                <h1>Hola</h1>
                <div className={styles["div4Reto"]} id="DivForChallenge"></div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalPrepagoConTarjeta;
